const lowerBlue = '#001CDB';

const palette = {
  grey100: '#e0e0e0',
  grey200: '#aeaeb1',
  grey300: '#7c7c81',
  grey400: '#666666',
  grey600: '#00023f',
  grey700: '#181b31',
  orange: lowerBlue,
  placeholder: lowerBlue,
};

const colors = {
  active: palette.placeholder,
  black: '#000000',
  currentSession: lowerBlue,
  error: '#fc4c6c',
  form: palette.placeholder,
  homeAuto: palette.placeholder,
  hover: '#0039ff',
  info: lowerBlue,
  mortgage: palette.placeholder,
  primary: palette.orange,
  realEstate: palette.placeholder,
  savings: palette.placeholder,
  secondary: palette.grey700,
  splashBackground: '#1000f5',
  splashPlanet: '#ffffff',
  splashRing: '#78b9fc',
  splashSun: '#ffffff',
  text: palette.grey200,
  textDark: palette.grey600,
  textDarker: palette.grey400,
  transparentPrimary: palette.placeholder,
  white: '#ffffff',
};

export {
  palette, colors,
};
